<template lang="pug">
ul.linkedTabs(:class="{ 'linkedTabs--round': round }")
  slot
</template>

<script>
export default {
  props: {
    round: { type: Boolean, default: () => false },
  },
}
</script>

<style lang="scss" scoped>
.linkedTabs {
  background: #4a381c;
  border-radius: 5px 5px 0 0;
  display: flex;
  list-style-type: none;
  margin: 0;
  padding: 0;

  &--round {
    background: transparent;
  }
}
</style>
